import { Box, List, ListItem, ListItemText, Typography } from '@mui/material';
import { addGeofenceCheckedId, setFilterTab } from 'app/actions/map';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
const taskColumnsWithoutDut = config.mapTransportTaskColumns.filter((column) => column.name !== 'dut');
const MapTaskInfoList = () => {
    var _a;
    const dispatch = useDispatch();
    const { ref: mapRef, geofenceCheckedId, taskSelectedItem, filterTab } = useSelector((state) => state.map);
    if (!taskSelectedItem) {
        return null;
    }
    const handleItemColumnClick = (value) => {
        var _a, _b, _c, _d;
        if (value.geofence_id != null && geofenceCheckedId.indexOf(value.geofence_id) === -1) {
            dispatch(addGeofenceCheckedId(value.geofence_id));
        }
        if (filterTab !== 'geofence') {
            dispatch(setFilterTab('geofence'));
        }
        (_b = (_a = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _a === void 0 ? void 0 : _a.handleClosePopup) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (value.latitude != null && value.longitude != null) {
            (_d = (_c = mapRef === null || mapRef === void 0 ? void 0 : mapRef.current) === null || _c === void 0 ? void 0 : _c.handleFlyTo) === null || _d === void 0 ? void 0 : _d.call(_c, [value.latitude, value.longitude]);
        }
    };
    return (React.createElement(Box, { component: 'div', sx: {
            width: '100%',
            height: '100%',
        } },
        React.createElement(List, { disablePadding: true, sx: (theme) => ({
                padding: theme.spacing(0),
                border: '1px solid',
                borderColor: theme.palette.divider,
                borderRadius: theme.shape.borderRadius,
                overflow: 'hidden',
            }) },
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    width: '100%',
                    height: '100%',
                    zIndex: '2',
                    pointerEvents: 'none',
                    padding: theme.spacing(0),
                    '.MuiListItemText-root': {
                        display: 'flex',
                        justifyContent: 'space-between',
                        height: '100%',
                        position: 'relative',
                        flex: 'none',
                        '&:before': {
                            content: '""',
                            position: 'absolute',
                            top: '0',
                            right: '0',
                            height: '100%',
                            bgcolor: theme.palette.divider,
                            width: '1px',
                            zIndex: '1',
                            pointerEvents: 'none',
                        },
                        '&:last-of-type': {
                            flex: '1',
                            '&:before': {
                                display: 'none',
                            },
                        },
                    },
                }) }, taskColumnsWithoutDut.map((column) => (React.createElement(ListItemText, { key: column.name, style: { width: column.width } })))),
            React.createElement(ListItem, { disablePadding: true, sx: (theme) => ({
                    width: '100%',
                    userSelect: 'none',
                    borderRadius: '0',
                    '.MuiListItemText-root': {
                        display: 'flex',
                        flex: 'none',
                        margin: theme.spacing(0),
                        padding: theme.spacing(1),
                        alignItems: 'center',
                        bgcolor: 'background.default',
                        borderBottom: '1px solid',
                        borderColor: theme.palette.divider,
                        '&:first-of-type': {
                            paddingLeft: theme.spacing(2),
                        },
                        '&:last-of-type': {
                            flex: '1',
                            paddingRight: theme.spacing(2),
                        },
                        '.MuiTypography-root': {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        },
                    },
                }) }, taskColumnsWithoutDut.map((column) => (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                React.createElement(Typography, null, column.label))))),
            ((_a = taskSelectedItem.ttn_task) !== null && _a !== void 0 ? _a : []).map((ttnTask, key) => (React.createElement(ListItem, { key: key, disablePadding: true, sx: (theme) => ({
                    width: '100%',
                    userSelect: 'none',
                    borderRadius: '0',
                    '.MuiListItemText-root': {
                        display: 'flex',
                        flex: 'none',
                        margin: theme.spacing(0),
                        padding: theme.spacing(0.5, 1),
                        alignItems: 'center',
                        '&:first-of-type': {
                            paddingLeft: theme.spacing(2),
                        },
                        '&:last-of-type': {
                            flex: '1',
                            paddingRight: theme.spacing(2),
                        },
                        '.MuiTypography-root': {
                            overflow: 'hidden',
                            whiteSpace: 'nowrap',
                            textOverflow: 'ellipsis',
                        },
                    },
                }) }, taskColumnsWithoutDut.map((column) => {
                switch (column.name) {
                    case 'section':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, ttnTask.section)));
                    case 'gs_num':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, sx: {
                                width: column.width,
                                cursor: ttnTask.geofence_id ? 'pointer' : 'default',
                            }, onClick: () => handleItemColumnClick(ttnTask) },
                            React.createElement(Typography, null, ttnTask.gs_num)));
                    case 'product':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, ttnTask.product)));
                    case 'volume':
                        return (React.createElement(ListItemText, { key: column.name, disableTypography: true, style: { width: column.width } },
                            React.createElement(Typography, null, ttnTask.volume)));
                    default:
                        return null;
                }
            })))))));
};
export default MapTaskInfoList;
